import React from 'react';
import PropTypes from 'prop-types';
import {saveAs} from 'file-saver';
import moment from 'moment-timezone';
// Helper function to transform your event format to the required format
function transformEventForDownload(event) {
  // Extract the necessary information
  const {
    date, // this is the start date and time
    title,
    description,
    timezone,
    imageURL: url,
    location
  } = event;

  // Parse the date and time as Pacific Time directly
  const eventDate = moment.tz(event.date, 'YYYY-MM-DDTHH:mm:ss.SSS', 'America/Los_Angeles');

  // Format the start date/time for ICS (this maintains the Pacific Time zone)
  const startDateString = eventDate.format('YYYYMMDDTHHmmss');

  // Assuming a 1-hour event duration for the end date
  const endDate = eventDate.clone().add(1, 'hours');
  const endDateString = endDate.format('YYYYMMDDTHHmmss');

  // Transform the data into the new event format
  return {
    title,
    description,
    startDate: startDateString,
    endDate: endDateString,
    location: location || 'Online Event', // or use a field from your event object if available
    url,
    filename: title.replace(/\s+/g, '_') // Create a filename-friendly version of the title
  };
}

// Helper function to format dates in the 'YYYYMMDDTHHmmss' format
function formatCalendarDate(date) {
  const pad = num => (num < 10 ? `0${num}` : num);

  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1); // months are zero-indexed
  const day = pad(date.getDate());
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  const seconds = pad(date.getSeconds());

  return `${year}${month}${day}T${hours}${minutes}${seconds}`;
}

// You can now pass 'formattedEvent' to the CalendarEventDownload component

const CalendarEventDownload = ({event}) => {
  if (!event || !event.title || !event.date) return null;
  const formattedEvent = transformEventForDownload(event);

  const handleDownload = () => {
    let icsData = [
      'BEGIN:VCALENDAR',
      'VERSION:2.0',
      'CALSCALE:GREGORIAN',
      'BEGIN:VEVENT',
      `SUMMARY:${formattedEvent.title}`,
      `DESCRIPTION:${formattedEvent.description} ${
        formattedEvent.location ? `\nLOCATION:${formattedEvent.location}` : ''
      }`,
      // Ensure the date strings are in the correct format
      `DTSTART;TZID=America/Los_Angeles:${formattedEvent.startDate}`,
      `DTEND;TZID=America/Los_Angeles:${formattedEvent.endDate}`,
      `LOCATION:online`,
      `URL:${formattedEvent.url}`,
      'END:VEVENT',
      'END:VCALENDAR'
    ].join('\n');
    console.log('icsData ', icsData);
    const blob = new Blob([icsData], {type: 'text/calendar;charset=utf-8'});
    saveAs(blob, `${formattedEvent.filename}.ics`);
  };

  return (
    <div>
      <button className="btn btn-secondary px-5" onClick={handleDownload}>
        Save the Date
      </button>
    </div>
  );
};

// Define the expected props and their types
CalendarEventDownload.propTypes = {
  event: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    startDate: PropTypes.string.isRequired, // This should be in the format: 'YYYYMMDDTHHmmss'
    endDate: PropTypes.string.isRequired, // This should be in the format: 'YYYYMMDDTHHmmss'
    location: PropTypes.string,
    url: PropTypes.string,
    filename: PropTypes.string // The desired filename for the downloaded .ics file
  }).isRequired
};

export default CalendarEventDownload;
